<!--<button (click)="open(content)"-->
<!--        aria-controls="staticBackdrop"-->
<!--        class="btn btn-white d-print-none"-->
<!--        data-bs-target="#staticBackdrop" data-bs-toggle="offcanvas" style="position:fixed;     top: 50%;-->
<!--    right: 0;-->
<!--    border-top-left-radius: 20px;-->
<!--    border-bottom-left-radius: 20px;-->
<!--" type="button">-->
<!--  <i class="far fa-toolbox"></i>-->
<!--</button>-->


<ng-template #content let-offcanvas>
  <div class="offcanvas-header">
    <h2 class="offcanvas-title text-primary" id="offcanvas-basic-title"><i class="far fa-toolbox"></i> <span
            class="ms-2">Boîte à Outils</span></h2>
  <button (click)="offcanvas.dismiss('Cross click')" aria-label="Close" class="btn-close" type="button"></button>
</div>
<div class="offcanvas-body">

  @if (state === ToolboxStateEnum.Home) {
    <div>
      <h3 class="mb-3"><i class="fas fa-toolbox"></i> <span class="ms-2">Outils rapides</span></h3>
      <div class="list-group">
        <button (click)="goTo(ToolboxStateEnum.SalaryContributions)" aria-current="true"
          class="list-group-item list-group-item-action"
          href="#">
          <i class="fas fa-hands-usd"></i> <span class="ms-3">Cotisations Salariales</span>
        </button>
        <!--                <button href="#" class="list-group-item list-group-item-action" aria-current="true">-->
        <!--                    <i class="fas fa-piggy-bank"></i> <span class="ms-3">RRQ</span>-->
      <!--                </button>-->
    </div>
    <hr class="mt-4">
    <h4 class="mt-4 text-secondary"><i class="fas fa-clock"></i> <span class="ms-2">Historique</span></h4>
    <div class="list-group">
      @for (quickCalculation of quickCalculations$ | async ; track quickCalculation) {
        <a (click)="loadQuickCalculation(quickCalculation)"
          aria-current="true"
          class="list-group-item list-group-item-action"
          href="#">
          <h4>{{ quickCalculation.title }}</h4>
          @if (quickCalculation.type === 'WITHHOLDING_TAX') {
            <div class="badge text-bg-light"><i
              class="fas fa-hands-usd"></i> <span class="ms-3">Cotisations Salariales</span></div>
            }
            <small class="ms-3"><i class="fal fa-clock"></i><span
          class="ms-2">{{ this.getDateText(quickCalculation.updatedAt) }}</span></small>
        </a>
      }
      @if ((quickCalculations$ | async).length === 0) {
        <a aria-current="true"
          class="list-group-item list-group-item-action"
          href="#">
          Aucun calcul.
        </a>
      }
    </div>
  </div>
}
@if (state === ToolboxStateEnum.SalaryContributions) {
  <div>
    <div class="d-flex align-items-center">
      <div (click)="goTo(ToolboxStateEnum.Home)" class="btn btn-light"><i class="fas fa-chevron-left"></i></div>
      <h3 class="ms-3 mb-0 flex-fill">Contributions salariales</h3>
      <div class="dropdown ps-4 pt-2 pe-3 pe-md-0">
        <a aria-expanded="false" aria-haspopup="true" class="dropdown-ellipses dropdown-toggle"
          data-bs-toggle="dropdown" href="#" role="button">
          <i class="fas fa-lg fa-ellipsis-v"></i>
        </a>
        <div class="dropdown-menu dropdown-menu-end mt-3">
          <a (click)="$event.preventDefault();" class="dropdown-item" href="#">
            <i class="fas fa-fw fa-cloud-download me-2"></i> Exporter le calcul
          </a>
        </div>
      </div>
    </div>
    <div>
      <app-quick-salary-contributions-form
      [quickCalculationCache]="quickCalculationSelected"></app-quick-salary-contributions-form>
    </div>
  </div>
}
</div>
</ng-template>
